import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroQuoteForm.XeroQuoteTextInfoSection', {
    titleFieldTitle: 'Title',
    titleFieldPlaceholder: 'Enter title',
    summaryFieldTitle: 'Summary',
    summaryFieldPlaceholder: 'Enter summary',
});
